import React, { useEffect, useState } from "react";
import "../../styles/college-syllabus/main.css";
import { getAllSyllabus } from "../../Services/AllAPIs";
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {
    const [loader, setLoader] = useState(true);
    const [coursesData, setCoursesData] = useState([]);
    const [error, setError] = useState(null);

    const getSyllabus = () => {
        getAllSyllabus()
            .then((res) => {
                // console.log('----->', res.data);
                setCoursesData(res.data);
                setLoader(false);
            })
            .catch((error) => {
                setError("An error occurred while fetching department data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getSyllabus();
    }, []);

    return (
        <div id="collegeSyllabusMain">
            <div className="container mt-5 mb-5 admin-container">
                <div className="new-things">
                    {loader && <LoadingSpinner />}

                    {error && <div className="error">{error}</div>}

                    {/* Loop through the courses data */}
                    
                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.A.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>B.A.B.Ed I year</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(B.A.%20B.Ed.%20-%20I%20Year).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.B.Ed II year</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(B.A.%20B.Ed.%20-%20II%20Year).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.B.Ed III year</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(B.A.%20B.Ed.%20-%20III%20Year).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.B.Ed IV year</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(B.A.%20B.Ed.%20-%20IV%20Year).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.J.M.C 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(B.AJMC%20(w.e.f.%202021-22)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. I Year Poltical Sc.</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A/syl(Political%20Science).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.A. NEP
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>BA NEP BLISc 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/B.A.%20NEP%202020.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BA Sanskrit NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/B.A._Sanskrit-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Economics NEP 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/BA(NEP)_Economics_2024-25%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. English NEP 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/BA-English-2022-23-NEP.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. History NEP 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/BA-NEP-History.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Psychology NEP 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/ba-nep-rev-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Education NEP 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/Education_BA_NEP_2020-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Geography NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/geography-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Political Science NEP</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/Pol-Sc_BA-BoS-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Hindi NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/re-hindi-ug-nep_2021-22.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Social Work NEP 2020-21</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/social-work-ba-nep.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Spoken Sanskrit NEP 2020-21</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/social-work-ba-nep.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Sociology NEP 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl(B.A.%20Sociology%20NEP%20(2023-24))%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. urdu NEP 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl(B.A.%20Urdu%20NEP).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Hindi NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl(B.A._Hindi_NEP).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. Sanskrit NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl(Sanskrit-NEP).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>UG Minor Course in Sanskrit NEP</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl(U.G.%20Minor%20Course%20in%20Sanskrit%20(NEP)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A. History NEP 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.A.%20NEP/syl_ba_nep_histroy_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.J.M.C.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>Bachelor in Film and Theatre Studies 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.J.M.C/bachelor-film-theatre.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                    
                                                <tr>
                                                    <td>B.A.J.M.C 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.J.M.C/syl(Bachelor%20of%20Journalism%20and%20Mass%20Communication%20(B.J.M.C.)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.J.M.C 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/BAJMC%20College%20Syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        BLISc / MLISc
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>B.A. NEP BLISc 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/B.A.%20NEP%202020.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>BLISc NEP 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/BLISc%20NEP%202020.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>MLISc NEP 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/MLISs%202025-26.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.Sc. NEP
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>B.Sc. (Hons.) Agriculture 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/B.Sc.%20(Hons.)%20Agriculture%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Botany NEP 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/syllabus_botany_nep.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Physics NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/B.Sc_Physics_NEP.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Chemistry NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/Chemistry-NEP-Syllabus-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Revised B.Sc. Chemistry NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/Chemistry-NEP-Syllabus-new.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Industrial Chemistry</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/Ind-Chem.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Mathametics NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/syl(B.Sc._Maths)_NEP_21-22.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Physics NEP 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/syl(B.Sc._Physics_NEP).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.Sc. Zoology NEP</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/B.Sc.%20NEP/Zoology-BSc-NEP-n.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        LL.B.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Labour & Industrial Law</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/05/labour%20and%20industrial%20law.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.LL.B 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/LL.B/1%20ballb%20syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.LL.B 3yrs (6 Sem.) 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/LL.B/2%20llb%20syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.A.LL.B Updated syllabus 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/LL.B/4%20ballb%20llb%20updated%20syllabus%20august%202024%20via%20bos.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Law Minor Elective</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/LL.B/6%20law%20minor%20elective%20related%20letter%20on%20website.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        LL.M.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>LL.M 2017-18</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/LL.M/3%20llm%20syllabus.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.A.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.A. Ancient Indian History, Culture, Archaeology 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/ma_nep_ancient_india_history_culture_archaeology_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A.J.M.C. 2025</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/majmc.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A.J.M.C. 2021-22</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(MAJMC-(w.e.f.%202021-22)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. History NEP 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl_ma_nep_history_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. History 2019-20</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(History)%20(2).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Home Science 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(M.A.%20Home%20Science).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Urdu 2019-20</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(M.A.%20Urdu).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Ed. Syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(M.Ed.%20(One%20Year)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science Yearly System</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(Political%20Science%20(Yearly%20System))-Private.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Political Science Semester System</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A/syl(Political%20Science%20(Semester%20System))-Regular.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.A. NEP
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                    <td>MA Economics (NEP) syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/02/M.A.%20Economics%20(NEP)_Final.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. English NEP 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A.%20NEP/M.A.%20(NEP)%20English%202024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. English NEP 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A.%20NEP/ma-eng-nep-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Sociology NEP 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A.%20NEP/M.A.%20Sociology%20(2023-24)_09-01-2024_1704778893.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Psychology NEP 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A.%20NEP/syl(M.A.%20Psychology%20(2022-23)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Urdu Minor Course 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.A.%20NEP/syl(M.A.%20Urdu%20Minor%20Course%20(2022-23)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. NEP Philosophy 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/06/ma-nep-philosophy.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>PG Minor Course Philosophy 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/06/pg-minor-philosophy.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.Com.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.Com. 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Com/m.com_2024-2025.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.F.A
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>B.F.D. Syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/02/BFD%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.F.D. Honours 2024-25 Syllabus</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/02/BFD%20Honours%202024-25_251231_142809.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.F.D. Ordinance & Evaluation Scheme</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/02/BDID%20ORDINANCE%20&%20EVALUATION%20SCHEME.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>B.F.D. Curricuium</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/02/Syllabus%20BDes-Fashion%20Design.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.F.A
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.F.A. Diploma Course 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.F.A/diploma_course_mfa_2024-25.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.A. Visual Art: Drawing & Painting 2024-25</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.F.A/visual-arts-draw-painting.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.A.J.M.C.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.A.J.M.C. 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.J.M.C/majmc.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.P.Ed.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.P.Ed.</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.P.Ed/syl(M.P.Ed.%20).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.Sc.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>M.Sc.(Ag.) Animal Husbandry & Dairying (formerly Dairy Sc.& Technology) 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/M.Sc.(Ag.)%20Animal%20Husbandry%20&%20Dairying%20(formerly%20Dairy%20Sc.&%20Technology)%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Agronomy 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/M.Sc.%20(Ag.)%20Agronomy%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Agricultural Chemistry  and Soil Sc. 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/M.Sc.%20(Ag.)%20Agricultural%20Chemistry%20%20and%20Soil%20Sc.%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Agricultural Economics 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/M.Sc.%20(Ag.)%20Agricultural%20Economics%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Agricultural Extension 2026-27</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/Syllabi%2010-Sept-2026/M.Sc.%20(Ag.)%20Agricultural%20Extension%202026-27%20(1).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Chemistry 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/05/msc%20chem%202023-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. (Ag.) Plant Pathology 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/04/msc-ag-plant-pathology.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Physics 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/10/msc-phy-college.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Biochemistry</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl_M.Sc.(Biochemistry)_old.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Biochemistry 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl_M.Sc(Biochemistry)new.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.Sc. Chemistry 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/msc-chem-nep-open-elective-23-24.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. (Ag) Genetics and Plant Breeding</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl(M.Sc.%20(Ag.)%20(as%20per%20ICAR%20Recommendations)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Physics 2016-17</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl(M.Sc.%20Physics).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Physics 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl(M.Sc.%20Physics-Revised).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Maths 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syl(M.Sc._Maths).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Maths 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/01/Syllabus%20(M.Sc.%20Mathematics).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M. Sc. Botany 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/M.Sc/syllabus-msc(botany)_CBCS.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        B.B.A.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr>
                                                    <td>BBA and BBA (Honours/ Research) 2026-27 (New)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/BBA%202026-27_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                              
                                                <tr>
                                                    <td>Bachelor in Business Administration Honours & Honours with Research 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/09/BBA-Hon-NEP-2025-26.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        M.B.A.
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              
                                                <tr>
                                                    <td>M.B.A. (Hospital Administration) 2026-27 (New)</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/MBA%20HA%202026-27_compressed.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>M.B.A. Syllabus Old</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/MBA/syllabus_mba.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row-new" >
                            <div className="pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2
                                        style={{ fontSize: 15 }}
                                        className="my-heading text-center"
                                    >
                                        Pre-Ph.D
                                    </h2>
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of Subject</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Pre-Ph.D. Agricultural Extension</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/05/DocScanner%20May%204,%202026%2011-48%20AM.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Agriculture Economics 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2026/04/New%20Doc%2004-24-2026%2011.35.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Botany 2022-23</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/pre-phd(Botany).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. History</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/pre-phd-course-history.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. History 2022</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D%20Course%20Work-Histroy).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Law</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D%20Course%20Work-Histroy).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. English 2024</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/pre-phd-course-work-english-2024.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Sanskrit</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Ph.D.%20Course%20Work%20(Sanskrit)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Education</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre%20Ph.D.%20Coursework%20-%20Education).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Physical Education 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20(Physical%20Education)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Home Science 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20Coursework%20(Home%20Science)).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Economics</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20Coursework%20in%20Economics).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Physics 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20coursework).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Political Science 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20Coursework-Political_sc).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Horticulture</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20Horticulture).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Statistics 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D.%20Statistics).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Mathametics 2022</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Ph.D._Mathematics).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Political Science</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-phd%20Political%20Science).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Geography 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-PhD.%20Course%20Work%20Geography).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Commerce & Business Administration 2023-24</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-PhD.%20Course%20Work).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Hindi 2014-15</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Phd-Hindi%20).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Hindi 2019-20</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syl(Pre-Phd-Hindi-02).pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Botany 2023</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/Colleges_syll/Pre-Ph.D/syllabus_pre.phd_botany.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Pre-Ph.D. Philosophy 2025-26</td>
                                                    <td>
                                                        <button className="btn btn-primary btn-download">
                                                            <a
                                                                href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/06/pre-phd-philosophy.pdf"
                                                                target="_blank"
                                                                rel="noopener noreferrer" 
                                                            >
                                                                Download
                                                            </a>
                                                        </button>
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
